// bundle picker for flex bundles
// reads selected products from DOM and injects _components into the product form at submit time

document.addEventListener('DOMContentLoaded', () => {
  const picker = document.querySelector('[data-bundle-picker]');
  if (!picker) return;

  const section = picker.closest('.shopify-section');
  const form = section?.querySelector('product-form-component form');
  if (!form) return;

  function findSelected() {
    const slots = picker.querySelectorAll('[data-bundle-slot]');
    const items = [];

    slots.forEach((slot) => {
      const selected = slot.querySelector('.bundle-picker__option--selected');
      if (!selected) return;

      const variantId = selected.dataset.variantId;
      const title = selected.dataset.title;
      const sku = selected.dataset.sku;

      items.push({
        variantId: variantId || '',
        title: title || '',
        sku: sku || '',
      });
    });

    return items;
  }

  function syncFormInputs() {
    form.querySelectorAll('[data-bundle-input]').forEach((el) => el.remove());

    const items = findSelected();
    const components = [];

    const bundleName = picker.dataset.bundleName || '';
    const parentSku = picker.dataset.parentSku || '';
    const bundleSkus = items.filter((it) => it.variantId).map((it) => it.sku);

    items.forEach((item, i) => {
      if (!item.variantId) return;

      components.push({
        id: parseInt(item.variantId, 10),
        quantity: 1,
        attributes: {
          _bundle: bundleName,
          _bundle_parent_sku: parentSku,
          _bundle_components: JSON.stringify(bundleSkus)
        }
      });

      const itemInput = document.createElement('input');
      itemInput.type = 'hidden';
      itemInput.name = `properties[_Item ${i + 1}]`;
      itemInput.value = item.title;
      itemInput.dataset.bundleInput = 'true';
      form.appendChild(itemInput);
    });

    if (components.length === 0) return;

    const componentsInput = document.createElement('input');
    componentsInput.type = 'hidden';
    componentsInput.name = 'properties[_components]';
    componentsInput.value = JSON.stringify(components);
    componentsInput.dataset.bundleInput = 'true';
    form.appendChild(componentsInput);
  }

  // inject on add-to-cart click — fires before form submit,
  // so inputs are present when handleSubmit creates FormData.
  // morph-proof: we read fresh DOM state every time.
  form.addEventListener('click', (e) => {
    if (e.target.closest('button[type="submit"]')) {
      syncFormInputs();
    }
  });

  // sync on load
  syncFormInputs();
});
